module.exports = __webpack_public_path__ + "static/media/ic_openLink.f45d5fa8.svg";